import type { ExcDtccUtcV1UtcFixSessionKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const FIX_SESSION_BASE_PATH = getResolvedPath('/clearing/operations/oms/fix-session');

export const getFixSessionPath: EntityPathBuilder<ExcDtccUtcV1UtcFixSessionKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return FIX_SESSION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.sessionId) {
        return undefined;
      }

      return getResolvedPath(`${FIX_SESSION_BASE_PATH}/$sessionId`, context.keys);
    }
  }
};

export function getFixSessionDetailPath(sessionId: string | undefined) {
  if (!sessionId) {
    return undefined;
  }

  return getFixSessionPath({ kind: 'detail', keys: { sessionId } });
}
